<script>
import gql from 'graphql-tag'
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
export default {
  name: 'Recipes',
  data () {
    return {
      container: null,
      page: 1,
      showMoreEnabled: true,
    }
  },
  mixins: [
    platformDetect,
  ],
  apollo: {
    container: {
      /*eslint-disable*/
      query: gql `query containers_par_categorie($categorie: String!, $limit: Int, $page: Int){
        containers_par_categorie(categorie: $categorie, limit: $limit, page: $page){
          id categorie_list description titre medias{
            id position image{
              titre url
            }
          }
        }
      }`,
      variables () {
        return { categorie: 'recette', limit: 4, page: this.page}
      },
      fetchPolicy: 'cache-first',
      update: data => data.containers_par_categorie,
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading (isLoading, countModifier) {
      // isLoading is a boolean
      // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      },
    },
  },
  components: {
    BaseLayout,
  },
  methods: {
    showMore () {
      if (this.page === 0) { this.page = 1 }
      this.page ++
      this.$apollo.queries.container.fetchMore({
        variables: {
          page: this.page,
        },
        updateQuery: (previousResult, {fetchMoreResult}) => {
          const newRes = fetchMoreResult.container
          const hasMore = fetchMoreResult.container.total
          if (hasMore > 4) {
            this.showMoreEnabled = true
          } else {
            if (hasMore > (4 * (this.page ++))) {
              this.showMoreEnabled = true
            } else {
              this.showMoreEnabled = false
            }
          }
          return {
            container: {
              container: [...previousResult.container, ...newRes],
              hasMore,
            },
          }
        },
      })
    },
  },
}
</script>
<template lang="pug">
base-layout

  div.backgroundtexture
  div.backgroundcolor
  div.recipes.overflow-x-hidden

    div.menucontent
      div.sectiontitre
        span.titretestintro THE <br>
        span.titretest RECIPES
        hr.lignemenu.mt4
      div.carousel
        div.carouselimages
          div.recettecard.relative.pointer(v-for='recette in container')
            router-link(:to="{name: 'info-recipe-show', params: {id: recette.id, titre: recette.titre, image: recette.medias[0].image.url, description: recette.description} }")
              div.recettetop
                img.imagerecette.inset-shadow(:src='recette.medias[0].image.url')
              div.recettebottom
                p.recettetitre {{recette.titre}}
                i.iconeplus.fa.fa-plus
</template>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/*ANIMATIONS*/
.backgroundtexture{
  -moz-animation: fadeIn 2;
  -webkit-animation: fadeIn 2s;
  animation: fadeIn 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.lignemenu{
  -moz-animation: zoomIn 2s 2s;
  -webkit-animation: zoomIn 2s 2s;
  animation: zoomIn 2s 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
/*ANIMATIONS END*/

::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}
.scrollbar{
  -ms-overflow-style: none;
}
@media only screen and (min-width: 320px){
  .backgroundblack{
    background-color: black;
    height: 100vh;
    width:100vw;
    z-index:-11;
    position:fixed;
  }
  .backgroundcolor{
  background: linear-gradient(233deg,#8f0000, #e30000, #ff0000);
  background-size: 200% 200%;
  min-width:100vw;
  width:100%;
  opacity:0.5;
  min-height:100vh;
  height:100%;
  z-index:-9;
  position:absolute;
  mix-blend-mode:hard-light;
  }
  .backgroundtexture{
  background-image: url("~@/assets/imgs_bg/fond6.jpg");
  background-size: cover;
  height: 100%;
  min-height: 100vh;
  width:100vw;
  z-index:-10;
  position:absolute;
  }
  .lignemenu{
    width:60%;
    max-width:500px;
    border-color: white!important;
    margin-bottom:0px !important;
    overflow: visible; /* For IE */
    height: 30px;
    border-style: solid;
    border-width: 1px 0 0 0;
    border-radius: 20px;
  }
  .lignemenu:after{
    display: block;
    content: "";
    height: 30px;
    margin-top: -31px;
    border-style: solid;
    border-color: white!important;
    border-width: 0 0 1px 0;
    border-radius: 20px;
  }
  .recettetitre{
    font-size:30px;
    text-align: center;
  }
  .iconeplus{
    position:absolute;
    bottom:0px;
    color:red;
    left:45%;
    padding-bottom:10px;

  }
  .logosection{
    padding-top: 25%;
  }
  .recipes{
    & .titresection{
      font-family:Abril Fatface;
      color: red;
      font-size: 20px;
      margin-bottom: 30px;
      & span{
        border-style: solid;
        border-width: 3px 0 3px 0;
        border-color: red;
        padding: 5px 10px 5px 10px;
      }
    }
    & .menucontent{
      width: 100%;
      padding-top: 30%;
      & .carousel{
        -moz-animation: slideInRight 1s 2s;
        -webkit-animation: slideInRight 1s 2s;
        animation: slideInRight 1s 2s;
        animation-fill-mode: both;
        width:100vw;
        margin-top:30px;
        padding-left:20px;
        /*padding-right:20px;*/
        overflow-x: auto;
        & .carouselimages{
          /*width:500px;*/
          display:inline-flex;
          white-space: no-wrap;

          & ::-webkit-scrollbar {
            width: 0px;
            background: transparent; /* make scrollbar transparent */
          }
          & .recettecard{
            width:240px;
            height:340px;
            margin:10px;
            background-color:white;
            border-radius:8px;
            & .recettetop{
              & .imagerecette{
                border-radius: 8px 8px 0 0;
              }
            }
            & .recettebottom{
              font-size:30px;
              font-family:Abril Fatface;
              font-weight: 100;
              padding:0px 10px 10px 10px;
              margin-top:10px;
              text-align: left;
            }
          }
        }
      }
      & .soustitrerecettes{
        color:white;
        font-family: Abril Fatface;
        font-size:35px;
      }
      & .sectiontitre{
        -moz-animation: fadeInDown 1s 1s;
        -webkit-animation: fadeInDown 1s 1s;
        animation: fadeInDown 1s 1s;
        animation-fill-mode: both;
        & .titretestintro{
          font-family: Abril Fatface;
          color:white;
          font-size:24px;
          text-align: center;
        }
        & .titretest{
          font-family: Abril Fatface;
          color:white;
          font-size:60px;
          text-align: center;
        }
      }
      & .lignemenu{
        width:60%;
        border-color: red;
        margin-bottom:20px;
      }
      & .menustyle{
        width: 280px;
        border-style: solid;
        border-width: 0 0 1px 0;
        text-align: left !important;
        border-color: red;
        padding:10px;
        font-family:Marketdeco;
        color: red;
        font-size: 20px;
        margin: 0 auto;
        margin-bottom: 20px;
      }
      & .menustyle2{
        width:200px;
        margin: 30px auto 20px;
        font-size:20px;
        line-height:24px;
      }
      & a{
        color:black;
      }
    }
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) and (orientation:landscape) {
.recipes{
  & .titrecontent{
    font-family:Marketdeco;
    color: red;
    font-size: 20px;
    margin-bottom: 30px;
    margin-top: 50px;
    & span{
      border-style: solid;
      border-width: 3px 0 3px 0;
      border-color: red;
      padding: 5px 10px 5px 10px;
    }
  }
  & .logosection{
    float:left;
    width: 45%;
    padding-top: 18%;
    padding-left:10%;
    /*height: 100vh;*/
  }
  & .menucontent{
    /*width: 90%;*/
    padding-top: 10%!important;
    & .menustyle{
      width: 280px;
      border-style: solid;
      border-width: 0 0 1px 0;
      text-align: left !important;
      border-color: red;
      padding:10px;
      /*font-family:Marketdeco;*/
      color: red;
      font-size: 18px;
      margin: 0 auto;
      /*margin-bottom: 20px;*/
    }
  }
}
}
@media only screen and (min-width: 768px){
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    right: 10%;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    left: 10%;
  }
  .recipes{
    & .logosection{
      padding-top: 18%;
    }
    & .contentsection{
      & .titresection{
        font-family:Marketdeco;
        color: red;
        font-size: 30px;
        margin-bottom: 50px;
        margin-top: 50px;
        & span{
          border-style: solid;
          border-width: 3px 0 3px 0;
          border-color: red;
          padding: 5px 10px 5px 10px;
        }
      }
      & .menucontent{
        width: 100%;
        & .menustyle{
          width: 500px;
          border-style: solid;
          border-width: 0 0 1px 0;
          text-align: left !important;
          border-color: red;
          padding:10px;
          /*font-family:Marketdeco;*/
          color: red;
          font-size: 26px;
          margin: 0 auto;
          margin-bottom: 20px;
        }
        & a{
          color:darkred;
        }
      }
    }
  }
}
@media only screen and (min-width: 768px) and (max-width:960px) and (orientation:landscape) {
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    right: 10%;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 5%;
    left: 10%;
  }
  .recipes{
    & .logosection{
      padding-top: 10%;
    }
    & .menucontent{
      width: 100%;
      padding-top: 20%;
    }
  }
}
@media only screen and (min-width: 961px){
  .boutonnext{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 50%;
    right: 5%;
  }
  .boutonlast{
    font-family:BritannicBold;
    font-size: 20px;
    bottom: 50%;
    left: 5%;
  }
  .recipes{
    & .menucontent{
      width: 100%;
      padding-top: 200px;
      & .menustyle2{
        font-size:80px;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// Recipes.vue?269c7206